import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=15b06022&scoped=true"
import script from "./FormEdit.vue?vue&type=script&lang=js"
export * from "./FormEdit.vue?vue&type=script&lang=js"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=15b06022&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b06022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b06022')) {
      api.createRecord('15b06022', component.options)
    } else {
      api.reload('15b06022', component.options)
    }
    module.hot.accept("./FormEdit.vue?vue&type=template&id=15b06022&scoped=true", function () {
      api.rerender('15b06022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinForm/FormEdit.vue"
export default component.exports